import { Link } from '@mui/material';
import { useSelector } from 'react-redux';

const Logo: React.FC = () => {
  const account = useSelector((state: any) => state.accounts.selected);

  let logoURL = `https://ticketingsystemadmina29b1f146cd8476b9f9aefcf325132756-dev.s3.us-east-2.amazonaws.com/public/jareed-logo.png`;

  if (account && account.logo && account.logo !== '') {
    logoURL = account.logo;
  }

  return (
    <Link color="inherit" underline="none" style={{ display: 'inline-block' }}>
      <img
        src={logoURL}
        alt="Logo"
        style={{
          width: 150,
          height: 150,
          objectFit: 'contain',
          display: 'block',
        }}
      />
    </Link>
  );
};

export default Logo;
